import React from "react";
import "../../assets/gamestatstable.css";
import Loader from "../Utils/Loader";
import { colors } from "../../assets/theme_setup";

const TeamTopPerformers = ({ gameHighs, loading }) => {
  if (loading) {
    return <Loader />;
  }

  if (!gameHighs || !gameHighs.home || !gameHighs.away) {
    return (
      <div className="team-top-performers-error">
        No game highs data available
      </div>
    );
  }

  // Convert the gameHighs object to an array for mapping
  const topPerformers = [gameHighs.home, gameHighs.away];

  // Define stat types with their icons and colors
  const statTypes = {
    scorer: {
      label: "Points",
      icon: "/points.png",
      key: "points",
      color: "#ff9800",
      gradient: "linear-gradient(135deg, #FF8C00, #FFAF38)",
    },
    rebounder: {
      label: "Rebounds",
      icon: "/rebounds.png",
      key: "total_rebounds",
      color: "#2196f3",
      gradient: "linear-gradient(135deg, #0277BD, #29B6F6)",
    },
    assist: {
      label: "Assists",
      icon: "/assists.png",
      key: "assists",
      color: "#4caf50",
      gradient: "linear-gradient(135deg, #2E7D32, #66BB6A)",
    },
  };

  return (
    <div className="game-highs-container">
      {topPerformers.map((team, teamIndex) => (
        <div key={teamIndex} className="game-highs-team">
          <div className="game-highs-team-header">
            <h3 className="game-highs-team-name">{team.teamName}</h3>
            <div className="game-highs-team-line"></div>
          </div>

          <div className="game-highs-cards-container">
            {Object.entries(statTypes).map(([statKey, statInfo]) => {
              const performer =
                team[
                  `top${statKey.charAt(0).toUpperCase() + statKey.slice(1)}`
                ];
              if (!performer) return null;

              return (
                <div
                  key={statKey}
                  className="game-highs-card"
                  style={{
                    background: statInfo.gradient,
                    boxShadow: `0 6px 12px rgba(0,0,0,0.15), 0 0 0 1px ${statInfo.color}40`,
                  }}
                >
                  <div className="game-highs-card-header">
                    <div className="game-highs-stat-icon-container">
                      <img
                        src={statInfo.icon}
                        alt={statInfo.label}
                        className="game-highs-stat-icon"
                      />
                    </div>
                    <h4 className="game-highs-stat-title">
                      Top {statInfo.label}
                    </h4>
                  </div>

                  <div className="game-highs-player-container">
                    <div className="game-highs-player-image-container">
                      <img
                        src={performer.image_url || "/default-player.png"}
                        alt={performer.player_name}
                        className="game-highs-player-image"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/default-player.png";
                        }}
                      />
                    </div>
                    <div className="game-highs-player-details">
                      <h3 className="game-highs-player-name">
                        {performer.player_name}
                      </h3>
                      <div className="game-highs-player-stat">
                        <span className="game-highs-stat-value">
                          {performer[statInfo.key]}
                        </span>
                        <span className="game-highs-stat-label">
                          {statInfo.key === "total_rebounds"
                            ? "REB"
                            : statInfo.key === "points"
                            ? "PTS"
                            : "AST"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamTopPerformers;
